// frontend/src/pages/LandingPage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * LandingPage.jsx
 * Phase 2 hardening:
 * - This legacy page previously surfaced "Compliance Control Center" and participated in old gating.
 * - We now force all entry traffic to /dashboard, where Supabase-backed entitlement gating lives.
 *
 * © 2026 Advanced Advisory Services, LLC. All Rights Reserved.
 */
export default function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Always go to the authoritative entry point.
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  // Render nothing (prevents flash of old UI).
  return null;
}